import { type FeatureModule } from '@store/features/types';

/**
 * Documents feature module definition
 */
export const documentsFeature: FeatureModule = {
  id: 'documents',
  name: 'Documents',
  dependencies: [],
  reducers: {},
  middleware: [],
  persistence: { enabled: false },
  sync: { enabled: false },
  setup: _store => {},
  cleanup: _store => {},
};

